<h2 mat-dialog-title>Schema Permissions</h2>

<mat-dialog-content class="mat-typography">
  <section class="user-info" aria-label="Selected user info">
    <div class="avatar" aria-hidden="true">
      {{ (data.name || data.email || 'U').charAt(0) | uppercase }}
    </div>
    <div class="user-meta">
      <div class="user-name">{{ data.name }}</div>
      <div class="user-email">
        <mat-icon inline>mail</mat-icon>
        <span>{{ data.email }}</span>
      </div>
    </div>
  </section>

  <mat-form-field appearance="outline" class="data-service-field">
    <mat-label>Data Service</mat-label>
    <mat-select
      [(ngModel)]="selectedConnection"
      (selectionChange)="loadSchemas()"
      [disabled]="isLoading || isSaving"
    >
      @for (dataService of dataServices; track dataService.string_connection) {
        <mat-option [value]="dataService.string_connection">
          {{ dataService.data_service_name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="schema-search-field">
    <mat-label>Search schemas</mat-label>
    <input
      matInput
      [(ngModel)]="schemaSearch"
      [disabled]="isLoading || isSaving || schemas.length === 0"
    />
    @if (schemaSearch) {
      <button
        matSuffix
        mat-icon-button
        type="button"
        aria-label="Clear schema search"
        (click)="schemaSearch = ''"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>

  @if (isLoading) {
    <div class="state-container" aria-label="Loading schemas">
      <mat-progress-spinner mode="indeterminate" class="bright-spinner"></mat-progress-spinner>
    </div>
  } @else if (!selectedConnection) {
    <div class="empty-state">No data services are available.</div>
  } @else if (schemas.length === 0) {
    <div class="empty-state">No schemas are available to manage in this data service.</div>
  } @else if (filteredSchemas.length === 0) {
    <div class="empty-state">No schemas match “{{ schemaSearch }}”.</div>
  } @else {
    <div class="table-wrapper">
      <table mat-table [dataSource]="filteredSchemas" class="schema-table">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Schema</th>
          <td mat-cell *matCellDef="let schema">{{ schema.name }}</td>
        </ng-container>

        <ng-container matColumnDef="hierarchy">
          <th mat-header-cell *matHeaderCellDef>Hierarchy</th>
          <td mat-cell *matCellDef="let schema">{{ schema.hierarchy }}</td>
        </ng-container>

        <ng-container matColumnDef="nodeLabel">
          <th mat-header-cell *matHeaderCellDef>Node Label</th>
          <td mat-cell *matCellDef="let schema">{{ schema.nodeLabel }}</td>
        </ng-container>

        <ng-container matColumnDef="permission">
          <th mat-header-cell *matHeaderCellDef>Permission</th>
          <td mat-cell *matCellDef="let schema">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="permission-field">
              <mat-label>Level</mat-label>
              <mat-select [(ngModel)]="schema.permission" [disabled]="isSaving">
                @for (level of permissionLevels; track level) {
                  <mat-option [value]="level">{{ level | titlecase }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <span class="selection-summary">
    {{ pendingChangesCount }} pending change{{ pendingChangesCount === 1 ? '' : 's' }}
  </span>
  <button mat-button (click)="onCancel()" [disabled]="isSaving">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    (click)="savePermissions()"
    [disabled]="isLoading || isSaving || pendingChangesCount === 0"
  >
    @if (isSaving) {
      <mat-progress-spinner mode="indeterminate" diameter="20" class="button-spinner"></mat-progress-spinner>
    } @else {
      Save
    }
  </button>
</mat-dialog-actions>
